import * as types from "../../mutation-types";
import Cookies from 'js-cookie'

export default {
	[types.SAVE_TOKEN] (state, { token, remember }) {
		Cookies.set('token', token, { expires: remember ? 24*0.125 : null })
		state.token = token;
	},

	[types.FETCH_USER_SUCCESS] (state, { user }) {
		state.user = user
	},

	[types.FETCH_USER_FAILURE] (state) {
		state.token = null
		Cookies.remove('token')
	},

	[types.LOGOUT] (state) {
		state.user = null
		state.token = null

		Cookies.remove('token')
	},

	[types.UPDATE_USER] (state, user) {
		state.user = user
	},

	[types.SHOW_MODAL] (state, modal) {
		state.modal = modal
	},

	[types.HIDE_MODAL] (state) {
 		state.modal = null
	},
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js